export default "__VITE_ASSET__DumA9Eu1__"